var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{style:(_vm.style),attrs:{"width":_vm.size,"height":_vm.size}},[_c('rect',{ref:"line",attrs:{"rx":_vm.size / 12,"width":_vm.size / 1.25,"height":_vm.size / 6,"fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }